import { render, staticRenderFns } from "./CbtSummary.vue?vue&type=template&id=32f89858"
import script from "./CbtSummary.vue?vue&type=script&lang=js"
export * from "./CbtSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports